import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { InsulinCartridgeOutlineIcon } from "@tandemdiabetes/sugarmate-react-components"
import classNames from "classnames"

import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import { isCartridgeFillLow } from "./isCartridgeFillLow"
import styles from "./PumpStatus.module.scss"

import type { DataRecency } from "src/types"

export interface Props extends ComponentPropsWithoutRef<"svg"> {
  pumpStatus: PumpStatus;
  pumpStatusRecency: DataRecency;
}

export const PumpCartridgeIcon = forwardRef<SVGElement, Props>(
  function PumpCartridgeIcon(props: Props, propRef: Ref<SVGElement>) {
    const {
      pumpStatus,
      pumpStatusRecency,
      ...svgProps
    } = props

    const { cartridge_fill: cartridgeFill } = pumpStatus

    const lowFill = isCartridgeFillLow(
      cartridgeFill,
      pumpStatusRecency,
    )

    return (
      <InsulinCartridgeOutlineIcon
        {...svgProps}
        className={classNames(
          svgProps.className,
          lowFill && styles.lowIcon,
        )}
        ref={propRef}
      />
    )
  },
)
